/* global MediaQueryState, Modernizr */

;(function () {
    'use strict';

    $(document).ready(function () {
        if (MediaQueryState.phones && Modernizr.touch) {
            document.cookie = 'm=1';
        }
    });
})();
